import styled, { css } from 'styled-components';
import { BKJButton } from '../BKJButton/index.js';
export const StyledButton = styled(BKJButton) `
  padding: 0 18px !important;
`;
export const BKJToggleInputWrapper = styled.label `
  position: relative;
  height: 28px;
  min-height: 28px;
  max-height: 28px;
  width: 80px;
  min-width: 80px;
  max-width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: visible;
`;
export const BKJToggleInputSwitchInput = styled.input `
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;
  &:disabled {
    cursor: not-allowed;
  }
`;
export const BKJToggleSliderTrack = styled.div `
  background-color: ${({ theme }) => theme.colors.Grey6};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
  border-radius: 18px;
  width: 100%;
  height: 100%;
  pointer-events: none;
  transition: background-color linear 100ms;
  ${({ disabled }) => disabled &&
    css `
      background-color: ${({ theme }) => theme.colors.Grey4};
    `}
  ${({ isSelected, disabled }) => {
    if (isSelected) {
        if (disabled) {
            return css `
          background-color: ${({ theme }) => theme.colors.SecondaryAcceptedDefault};
        `;
        }
        else {
            return css `
          background-color: ${({ theme }) => theme.colors.AccentGreen};
        `;
        }
    }
    return void 0;
}}
`;
export const BKJToggleButton = styled.div `
  position: absolute;
  left: 0%;
  height: 36px;
  min-height: 36px;
  max-height: 36px;
  width: 36px;
  min-width: 36px;
  max-width: 36px;
  background-color: ${({ theme, disabled }) => disabled ? theme.colors.Grey1 : theme.colors.White};
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  pointer-events: none;
  transition: left ease-in 100ms;

  ${({ isSelected }) => isSelected &&
    css `
      left: calc(100% - 36px);
    `}
`;
export const BKJToggleInputPillCheckDisplay = styled.div `
  width: 20px;
  height: 20px;
  border-radius: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  ${({ theme, variant, checked }) => {
    const innerVariant = variant === 'PurplePillLeft' || variant === 'PurplePillRight'
        ? 'PurpleOutlined'
        : 'PurpleSolid';
    return checked ? theme.checkbox[innerVariant].checked : theme.checkbox[innerVariant].unchecked;
}}

  ${({ disabled }) => disabled &&
    css `
      border-color: ${({ theme }) => theme.colors.Grey5};
      background-color: ${({ theme }) => theme.colors.Grey5};
      opacity: 0.5;
    `}

  ${({ variant }) => variant === 'PurplePillLeft' || variant === 'PurpleNoBorderLeft'
    ? css `
          margin-left: 8px;
        `
    : css `
          margin-right: 8px;
        `}
`;
export const BKJToggleInputPillLabelWrapper = styled.div `
  ${({ theme }) => theme.common.Ellipsis};
  ${({ color, disabled }) => !disabled &&
    color &&
    css `
      color: ${({ theme }) => theme.colors[color]};
    `}
  ${({ fontSize }) => fontSize &&
    css `
      font-size: ${fontSize}px;
    `}
`;
//# sourceMappingURL=BKJToggleInput.styled.js.map